import {defineStore} from 'pinia'
import {useSummaryData} from '~/composables/api/useSummaryApi'
import type {AppDataItem} from '~/types/types'

export const useAppDataStore = defineStore('appData', () => {
  const {getSummaryData} = useSummaryData()
  const {session} = useAuth()

  const appData = ref<AppDataItem>()
  const loading = ref(true)
  const Loaded = ref(false)

  // 3. Actions (standard functions)
  async function fetchData(forceRefresh = false) {
    loading.value = true
    try {
      if (!session.value?.data) {
        loading.value = false
        appData.value = {
          brands: [],
          cities: [],
          locations: [],
          products: [],
          regions: [],
          retailers: []
        }
        return
      }

      const data = (await getSummaryData(forceRefresh)) as AppDataItem
      appData.value = data
    } catch (error) {
      console.error('Failed to fetch stats:', error)
    } finally {
      loading.value = false
    }
  }

  // ========================================================
  // AUTOMATIC INITIALIZATION ZONE
  // ========================================================
  // run only on client side once Nuxt has mounted the app context
  if (import.meta.client) {
    // Watch for the session authentication validation to pass successfully
    watch(
      () => session.value?.data,
      (newSession) => {
        if (newSession && !Loaded.value) {
          fetchData()
        }
      },
      {immediate: true} // Run immediately in case session is already cached
    )
  }

  return {
    appData,
    loading,
    fetchData
  }
})
